/**
 * Unauthorized — shadow de @plone/volto 18.35.0.
 *
 * Idêntico ao original, com uma diferença (AB#12105): quando o frontend roda
 * com o login desligado (RAZZLE_LOGIN_DESLIGADO, só no público/www), a
 * página "não autorizado" não convida ao login. Antes, qualquer endereço
 * terminado em /contents, ou um link para conteúdo não publicado, mostrava
 * "acesse primeiro" com um link que levava ao formulário de login sem
 * recarregar a página, contornando o bloqueio da página /login na borda.
 */
import { FormattedMessage } from 'react-intl';
import { Container } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
// NavLink (permitido pela regra do tema) no lugar do Link: mantém o `state`
// isLogout que o original passa à rota de login.
import { NavLink, useLocation } from 'react-router-dom';
import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';
import { loginDesligado } from 'volto-ministerio-publico-federal/helpers/Auth/loginPublico';

export const TEXTO_RESTRITO_SEM_LOGIN =
  'Este conteúdo é restrito a usuários do portal e não está disponível por este endereço.';

const Unauthorized = () => {
  const token = useSelector((state) => state.userSession.token);
  const error_message = useSelector((state) => state.apierror?.message);
  let location = useLocation();
  const semLogin = loginDesligado();

  return (
    <Container className="view-wrapper">
      <BodyClass className="view-unauthorized" />
      <h1>
        <FormattedMessage id="Unauthorized" defaultMessage="Unauthorized" />
      </h1>
      <h3>{error_message}</h3>
      <p className="description">
        {token ? (
          <FormattedMessage
            id="You are trying to access a protected resource."
            defaultMessage="You are trying to access a protected resource."
          />
        ) : semLogin ? (
          TEXTO_RESTRITO_SEM_LOGIN
        ) : (
          <FormattedMessage
            id="You are trying to access a protected resource, please {login} first."
            defaultMessage="You are trying to access a protected resource, please {login} first."
            values={{
              login: (
                <NavLink
                  to={{
                    pathname: `${getBaseUrl(location.pathname)}/login`,
                    state: {
                      // This is needed to cover the use case of being logged in in
                      // another backend (eg. in development), having a token for
                      // localhost and try to use it, the login route has to know that
                      // it's the same as it comes from a logout
                      isLogout: true,
                    },
                  }}
                >
                  <FormattedMessage id="log in" defaultMessage="log in" />
                </NavLink>
              ),
            }}
          />
        )}
      </p>
      <p>
        <FormattedMessage
          id="If you are certain you have the correct web address but are encountering an error, please contact the {site_admin}."
          defaultMessage="If you are certain you have the correct web address but are encountering an error, please contact the {site_admin}."
          values={{
            site_admin: (
              <NavLink to="/contact-form">
                <FormattedMessage
                  id="Site Administration"
                  defaultMessage="Site Administration"
                />
              </NavLink>
            ),
          }}
        />
      </p>
      <p>
        <FormattedMessage id="Thank you." defaultMessage="Thank you." />
      </p>
    </Container>
  );
};
const UnauthorizedWithCode = withServerErrorCode(401)(Unauthorized);
UnauthorizedWithCode.displayName = 'unauthorized';
export default UnauthorizedWithCode;
